module.exports = __webpack_public_path__ + "img/陳啟秀-29-01.1d86d901.jpg";